/*
  Adeqo product-card component-JS.
  Verplaatst uit snippets/product-card-adeqo.liquid (was inline <script>, per kaart
  herhaald -> N dubbele DOMContentLoaded-listeners). Nu 1x met defer in de secties.
  Werkt via globale querySelectorAll over .adeqo-product-card, dus 1x laden volstaat.
*/
  document.addEventListener('DOMContentLoaded', function() {
    // Make entire card clickable
    document.querySelectorAll('.adeqo-product-card').forEach(function(card) {
      card.addEventListener('click', function(e) {
        if (e.target.closest('.adeqo-product-card__actions') || e.target.closest('button') || e.target.closest('select')) return;
        var link = card.querySelector('.adeqo-product-card__link');
        if (link) window.location.href = link.href;
      });
    });

    // Add to cart functionality
    document.querySelectorAll('.adeqo-product-card__add-to-cart').forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        // Voorkom dat de "hele kaart klikbaar"-handler navigeert: de innerHTML-swap
        // hieronder koppelt het geklikte SVG-icoon los, waardoor diens closest()-check
        // faalt en de kaart anders naar de productpagina zou navigeren.
        e.stopPropagation();

        const card = this.closest('.adeqo-product-card');
        const quantitySelect = card.querySelector('.adeqo-product-card__quantity-select');
        const variantId = this.dataset.variantId;
        const quantity = quantitySelect ? parseInt(quantitySelect.value) : 1;

        // Add loading state
        this.disabled = true;
        this.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="animate-spin"><circle cx="12" cy="12" r="10" stroke-dasharray="32" stroke-dashoffset="12"></circle></svg>';

        window.AdeqoCart.add(
          [{ id: parseInt(variantId), quantity: quantity }],
          { source: 'product-card' }
        )
        .then(() => {
          this.disabled = false;
          this.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"></polyline></svg>';

          setTimeout(() => {
            this.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>';
          }, 2000);
        })
        .catch(error => {
          console.error('Error:', error);
          this.disabled = false;
          this.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>';
        });
      });
    });
  });
